export default {
  '***': {
    extraFilter: {
      type: 'sampleSizeFilter',
      ad_type: ['***'],
      disabledState: 'hidden',
      data: {
        sampleSize: 0
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/configuration/Demo/InvestorServices/config/components/selection/Search/SearchFilter.js